import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { initErrorReporting } from './lib/observability'
import { initAnalytics, captureAttributionFromURL, initGoogleAds } from '@/lib/analytics'
import './index.css'

initErrorReporting()
initAnalytics()
initGoogleAds()
captureAttributionFromURL()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
